import { BoardViewFactory } from '../../game/boardMVC/views/board/BoardViewFactory';
import type { TileStackModel } from '../../game/boardMVC/models/board/TileStackModel';
import type { BlockerModel, BlockerView } from '../../game/boardMVC/types';
import { StarBlockerModel } from '../../game/boardMVC/models/blockers/StarBlockerModel';
import { EditorStarBlockerView } from './editorBoardViews/EditorStarBlockerView';

export class EditorBoardViewFactory extends BoardViewFactory {
  protected createBlockerViewInstance(stack: TileStackModel, model: BlockerModel): BlockerView | null {
    if (model instanceof StarBlockerModel) {
      return new EditorStarBlockerView(model);
    }

    return super.createBlockerViewInstance(stack, model);
  }
}
